import { useCallback, useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { X } from "react-feather";
import { Form, Row } from "reactstrap";

import RightHeader from "./rightbar";
import hasRoles from "../../security/hasRoles";
import styles from "./header.module.scss";

const Header = ({ className = "" }) => {
  const keycloak = useKeycloak().keycloak;
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  // eslint-disable-next-line
  const [searchValue, setsearchValue] = useState("");
  // eslint-disable-next-line
  // const [searchResult, setSearchResult] = useState(false);
  // eslint-disable-next-line
  // const [searchResultEmpty, setSearchResultEmpty] = useState(false);

  const escFunction = useCallback(event => {
    if (event.keyCode === 27) {
      setsearchValue("");
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  return (
    <div className={hasRoleAdmin ? `page-header ${styles["admin-page-header"]} ${className}` : `page-header ${styles["user-page-header"]} ${className}`}>
      {/* <Row className={keycloak.authenticated ? "header-wrapper m-0" : `${styles["agrisud-header"]} header-wrapper m-0`}> */}
      <Row className={`${styles["agrisud-header"]} header-wrapper m-0`}>
        <Form className="form-inline search-full" action="#" method="get">
          <div className="form-group w-100">
            <div className="Typeahead Typeahead--twitterUsers">
              <div className="u-posRelative">
                <div className="spinner-border Typeahead-spinner" role="status">
                  <span className="sr-only">Loading</span>
                </div>
                <X className="close-search" onClick={() => document.querySelector(".search-full").classList.remove("open")} />
              </div>
              <div className="Typeahead-menu empty-menu">
                <div className="tt-dataset tt-dataset-0">
                  <div className="EmptyMessage">Opps!! There are no result found.</div>
                </div>
              </div>
            </div>
          </div>
        </Form>
        <RightHeader />
      </Row>
    </div>
  );
};

export default Header;
